import React, { useEffect, useState } from 'react';
import { stations, users } from '../services/api';

const Filters = ({ onFilterChange, user }) => {
  const [stationList, setStationList] = useState([]);
  const [mechanicList, setMechanicList] = useState([]);
  const [dateType, setDateType] = useState('all'); // 'all' or 'custom'
  const [filterData, setFilterData] = useState({
    station_id: user?.role === 'admin' ? String(user?.station_id || '') : '',
    mechanic_id: '',
    date_from: '',
    date_to: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [stationsRes, mechanicsRes] = await Promise.all([
          stations.getAll(),
          users.getMechanicsList(),
        ]);
        setStationList(stationsRes.data.data);
        setMechanicList(mechanicsRes.data.data);
      } catch (err) {
        console.error('Failed to fetch filter options', err);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filterData, [name]: value };
    setFilterData(newFilters);
    onFilterChange(newFilters);
  };

  const handleDateTypeChange = (e) => {
    const type = e.target.value;
    setDateType(type);
    
    if (type === 'all') {
      const newFilters = { ...filterData, date_from: '', date_to: '' };
      setFilterData(newFilters);
      onFilterChange(newFilters);
    }
  };

  const handleReset = () => {
    setDateType('all');
    const resetFilters = {
      station_id: user?.role === 'admin' ? String(user?.station_id || '') : '',
      mechanic_id: '',
      date_from: '',
      date_to: '',
    };
    setFilterData(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border mb-6">
      <h2 className="text-lg font-semibold mb-4 text-gray-800">Filters</h2>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {user?.role !== 'admin' && (
          <div className="md:col-span-3">
            <label className="block text-xs font-medium text-gray-500 uppercase mb-1">AHASS</label>
            <select
              name="station_id"
              value={filterData.station_id}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">All AHASS</option>
              {stationList.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.code} - {s.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="md:col-span-3">
          <label className="block text-xs font-medium text-gray-500 uppercase mb-1">Mechanic</label>
          <select
            name="mechanic_id"
            value={filterData.mechanic_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Mechanics</option>
            {mechanicList.map((m) => (
              <option key={m.id} value={m.id}>
                {m.fullname}
              </option>
            ))}
          </select>
        </div>

        <div className="md:col-span-2">
          <label className="block text-xs font-medium text-gray-500 uppercase mb-1">Time Range</label>
          <select
            value={dateType}
            onChange={handleDateTypeChange}
            className="w-full px-3 py-2 border rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">All Time</option>
            <option value="custom">Custom Range</option>
          </select>
        </div>

        {dateType === 'custom' && (
          <>
            <div className="md:col-span-2">
              <label className="block text-xs font-medium text-gray-500 uppercase mb-1">From</label>
              <input
                type="date"
                name="date_from"
                value={filterData.date_from}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-xs font-medium text-gray-500 uppercase mb-1">To</label>
              <input
                type="date"
                name="date_to"
                value={filterData.date_to}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-md text-sm focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </>
        )}
      </div>

      
      <div className="mt-4 flex justify-end">
        <button
          onClick={handleReset}
          className="text-sm text-gray-600 hover:text-blue-600 font-medium transition duration-150"
        >
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default Filters;
